import Api from "../index";
import { endPoints, requestType } from "../../constants/variables";

// Login api

export const loginAdmin = (params) => {
  return Api(endPoints.loginAdmin, params, requestType.POST);
};

export const updateAdminProfile = (id, params) => {
  return Api(`${endPoints.updateAdminProfile}/${id}`, params, requestType.PUT);
};

export const changePasswordAdmin = (params) => {
  return Api(endPoints.changePasswordAdmin, params, requestType.POST);
};

export const getAllMatches = () => {
  return Api(endPoints.getAllMatches, null, requestType.GET);
};
